<template>
    <div class="invoice">
      <div class="invoice__loading" v-if="isLoading">
        <adx-loading-primary/>
      </div>
      <div v-else>
        <!-- Header -->
        <div class="invoice__header">
          <img src="/img/adx/adx-red.png" alt="">
          <span @click="print" class="noprint">Print <img src="/img/adxicon/ic-print@2x.png" alt=""></span>
        </div>
        <!-- ADX Information -->
        <div class="invoice__adx-information">
          <div class="invoice__adx-information__content">
            <p class="title">PT. Narada Sahara Kencana</p>
            <div><span>80.351.501.4-047.000</span></div>
            <div><span>Muara Karang Block D 7 B No.46 Jakarta Utara - 14450</span></div>
            <div><span>P : 021 - 6614822</span></div>
            <div><span>F : 021 - 6610192</span></div>
            <div><span>E : support@adxasia.co.id</span></div>
            <div><span>www.adxasia.co.id</span></div>
          </div>
        </div>
        <!-- Title -->
        <div class="invoice__title">
          <p class="bold">PAYMENT RECEIPT</p>
          <p>Receipt ID : {{ receiptNumber }}</p>
          <p>Order date : {{ receiptDate }}</p>
        </div>
        <div class="invoice__payment">
          <!-- Amount Paid -->
          <div class="invoice__payment__amount">
            <p>Amount Paid:</p>
            <span>{{ price | formatMoney}}</span>
          </div>
          <!-- Payment Status -->
          <div class="invoice__payment__status">
            <div class="invoice__payment__status__content">
              <p>Payment status :</p>
              <p class="paid">Paid</p>
            </div>
          </div>
        </div>
        <!-- User Information -->
        <div class="invoice__information">
          <div class="invoice__information__content">
            <p class="title">Bill to :</p>
            <div>
              <span><p>Name</p></span>
              <span><p>{{ user.name }}</p></span>
            </div>
            <div>
              <span><p>Phone</p></span>
              <span><p>{{ user.phone }}</p></span>
            </div>
            <div>
              <span><p>Email</p></span>
              <span><p>{{ user.email }}</p></span>
            </div>
            <div>
              <span><p>Address</p></span>
              <span><p>{{ user.address }}</p></span>
            </div>
          </div>
        </div>
        <!-- Invoice Summary -->
        <div class="invoice__detail">
          <div class="invoice__detail__title"><p>Invoice Summary :</p></div>
          <table>
            <thead>
              <tr>
                <td v-for="(header, index) in headers" :key="index">{{ header }}</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in transactions" :key="index" class="items">
                <td>
                  <div class="name">{{ item.name }}</div>
                  <div class="detail">{{ item.detail }}</div>
                </td>
                <td>
                  <div class="price">{{ item.price | formatMoney }}</div>
                </td>
              </tr>
              <tr class="subHeader">
                <td >Sub Total</td>
                <td class="price">{{ subTotal | formatMoney}}</td>
              </tr>
              <tr v-if="discount > 0" class="items">
                <td>
                  <div class="name">Discount</div>
                </td>
                <td>
                  <div class="price"><span>- </span> {{ discount | formatMoney }}</div>
                </td>
              </tr>
              <tr v-if="balance > 0" class="items">
                <td>
                  <div class="name">ADX Balance</div>
                </td>
                <td>
                  <div class="price"><span>- </span> {{ balance | formatMoney }}</div>
                </td>
              </tr>
              <tr class="subHeader">
                <td >Total Price</td>
                <td class="price">{{ price | formatMoney}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
</template>

<script>
import LoadingPrimary from '@/components/Loading/Primary'

import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-transaction-invoice',
  components: {
    'adx-loading-primary': LoadingPrimary,
  },
  data(){
    return {
      receiptId: ``,
      receiptNumber: '',
      receiptDate: '',
      price: 0,
      headers: [
        'Campaign Name',
        'Price'
      ],
      user: {
        name: '',
        phone: '',
        email: '',
        address: ''
      },
      transactions: [],
      isLoading: false,
      tax: 0,
      balance: 0,
      discount: 0,
    }
  },
  computed: {
    subTotal: function () {
      return this.price + this.balance + this.discount
    }
  },
  beforeMount() {
    const { receipt_id } = this.$route.params
    if (receipt_id) {
      this.receiptId = receipt_id
      this.loadData()
    } else {
      this.$router.replace({ name: `404` })
    }
  },
  methods: {
    loadData() {
      (async () => {
        this.isLoading = true
        const response = await api.get(apiV2.receiptDetail(this.receiptId), { needToken: true })
        if (response.status === 200) {
          const { data } = response
          this.mapData(data)
          this.isLoading = false
        } else {
          this.$router.replace({ name: `403` })
        }
      })();
    },
    mapData(data) {
      this.tax = data.tax_price
      this.receiptNumber = data.number
      this.receiptDate = data.last_updated
      this.price = data.gross_amount
      this.user = {
        name: data.user.full_name,
        phone: data.user.phone || '',
        email: data.user.email || '',
        address: data.user.address || ''
      }
      this.balance = data.total_balance
      this.discount = data.total_discount
      data.campaigns.map(campaign => {
        this.transactions.push({
          name: campaign.title,
          price: campaign.before_tax_price,
          detail: campaign.invoice_number
        })
      })
      this.transactions.push({
        name: 'PPN 10%',
        price: this.tax,
        detail: ''
      })
    },
    print() {
      window.print()
    },
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>

